import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import LandlordDash from "./LandlordDash";
import PropsListPage from "./PropsListPage";
import TenantsPage from "./TenantsPage";
import PayPage from "./PayPage";
import MaintPage from "./MaintPage";
import CCPage from "./CCPage";
import ChatListPage from "./ChatListPage";
import SettingsPage from "./SettingsPage";
import PropDetailPage from "./PropDetailPage";
import PropFormPage from "./PropFormPage";
import TenantFormPage from "./TenantFormPage";
import TenantDetailPage from "./TenantDetailPage";
import InvitePage from "./InvitePage";
import TenantPayHistoryPage from "./TenantPayHistoryPage";
import AddPayPage from "./AddPayPage";
import PaySettingsPage from "./PaySettingsPage";
import CCFormPage from "./CCFormPage";
import AgreementPage from "./AgreementPage";
import LeaseFormPage from "./LeaseFormPage";
import FaqPage from "./FaqPage";
import TermsPage from "../common/TermsPage";
import PrivacyPage from "../common/PrivacyPage";
import ServicePersonsPage from "./ServicePersonsPage";
import ServicePersonFormPage from "./ServicePersonFormPage";
import MapViewPage from "../common/MapViewPage";
import LeadsPage from "./LeadsPage";
import TeamPage from "./TeamPage";
import VacateInbox from "./VacateInbox";
import VacateDetailPage from "./VacateDetailPage";
import ReportsPage from "./ReportsPage";
import AnalyticsPage from "./AnalyticsPage";
import AIAssistantPage from "./AIAssistantPage";
import FeatureGate from "../common/FeatureGate";

function LandlordPage() {
  const { page } = useContext(Ctx);
  switch (page) {
    // Always accessible (basic_dashboard + payments are in every plan)
    case "dash": return <LandlordDash />;
    case "props": return <PropsListPage />;
    case "tens": return <TenantsPage />;
    case "pay": return <PayPage />;
    case "propDetail": return <PropDetailPage />;
    case "addProp": return <PropFormPage />;
    case "editProp": return <PropFormPage edit />;
    case "addTenant": return <TenantFormPage />;
    case "editTenant": return <TenantFormPage edit />;
    case "tenantDetail": return <TenantDetailPage />;
    case "inviteTenant": return <FeatureGate feature="whatsapp"><InvitePage /></FeatureGate>;
    case "tenantPayHistory": return <TenantPayHistoryPage />;
    case "addPay": return <AddPayPage />;
    case "paySettings": return <PaySettingsPage />;
    case "chatList": return <ChatListPage />;
    case "settings": return <SettingsPage />;
    case "faq": return <FaqPage />;
    case "terms": return <TermsPage />;
    case "privacy": return <PrivacyPage />;
    case "leads": return <LeadsPage />;
    case "mapView": return <MapViewPage />;

    // Maintenance — requires "maintenance" feature (Starter+)
    case "maint": return <FeatureGate feature="maintenance"><MaintPage /></FeatureGate>;
    case "cc": return <FeatureGate feature="maintenance"><CCPage /></FeatureGate>;
    case "ccForm": return <FeatureGate feature="maintenance"><CCFormPage /></FeatureGate>;

    // Agreements (unified lease + agreement management) — requires "leases" feature (Starter+)
    case "agreement":
    case "leases":
    case "leaseDetail":
    case "tenAgr":
      return <FeatureGate feature="leases"><AgreementPage /></FeatureGate>;
    // Standalone create/edit lease form — "Create Lease" from PropDetail
    // used to land on the agreements LIST (no create UI), a dead end.
    case "leaseForm":
      return <FeatureGate feature="leases"><LeaseFormPage /></FeatureGate>;
    case "editLease":
      return <FeatureGate feature="leases"><LeaseFormPage edit /></FeatureGate>;

    // Service Persons — requires "service_persons" feature (Starter+)
    case "servicePersons": return <FeatureGate feature="service_persons"><ServicePersonsPage /></FeatureGate>;
    case "addServicePerson": return <FeatureGate feature="service_persons"><ServicePersonFormPage /></FeatureGate>;
    case "editServicePerson": return <FeatureGate feature="service_persons"><ServicePersonFormPage edit /></FeatureGate>;

    // Reports — requires "reports" feature (Growth+)
    case "reports": return <FeatureGate feature="reports"><ReportsPage /></FeatureGate>;

    // Analytics — visual insights (revenue trend + KPIs). No feature
    // gate because the Revenue Trend chart was previously on every
    // landlord's dashboard, free or paid.
    case "analytics": return <AnalyticsPage />;

    // Team — requires "multi_user" feature (Pro)
    case "team": return <FeatureGate feature="multi_user"><TeamPage /></FeatureGate>;

    // AI Assistant — requires "analytics" feature (Pro)
    case "aiAssistant": return <FeatureGate feature="analytics"><AIAssistantPage /></FeatureGate>;

    // Vacate flow — landlord inbox + detail review. No feature-gate;
    // every plan supports the move-out workflow.
    case "vacateInbox": return <VacateInbox />;
    case "vacateDetail": return <VacateDetailPage />;

    default: return <LandlordDash />;
  }
}

export default LandlordPage;
